import axios from 'axios';
import { ASK_GROWTH_API_BASE_URL } from '../config/apiConfig';

const newFeaturesApi = axios.create({
  baseURL: ASK_GROWTH_API_BASE_URL,
});

newFeaturesApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const listFeatureCards = (tab, showDeleted = 0) => {
  const params = { show_deleted: showDeleted };
  if (tab && tab !== 'All') params.tab = tab;
  return newFeaturesApi.get('/new_features/list_feature_cards', { params });
};

export const addFeatureCard = (formData) =>
  newFeaturesApi.post('/new_features/add_feature_card', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteFeatureCard = (featureCardId) =>
  newFeaturesApi.delete('/new_features/delete_feature_card', {
    params: { feature_card_id: featureCardId },
  });

export const sendEmails = (featureCardId) =>
  newFeaturesApi.post('/new_features/send_emails', null, {
    params: { feature_card_id: featureCardId },
  });
